import { Serializable } from "../utilities/Serializable";
import { ProductCategory } from "./ProductCategory";
import { TaxRate } from "./TaxRate";
import { UnitOfMeasure } from "./UnitOfMeasure";

export class Product extends Serializable {
    uuid: string;
    code: string;
    barcode: string;
    stockCode: string;
    description: string;
    icon: string;
    unitOfMeasure: UnitOfMeasure;
    minSellingAmount: number;
    price: number;
    taxrate: TaxRate;
    category: ProductCategory;
}


// WEBPACK FOOTER //
// ./src/app/models/Product.ts